import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import i18n from "../langs/translations";

interface TranslationsState {
    lang: string;
}

const initialTranslationState: TranslationsState = {
    lang: 'en'
}

export const translationSlice = createSlice({
    name: 'translation',
    initialState: initialTranslationState,
    reducers: {
        changeLanguage: (state, action: PayloadAction<string>) => {
            if (action.payload) {
                state.lang = action.payload;
                i18n.changeLanguage(action.payload.toLowerCase());
            }
        }
    }
})

export const {changeLanguage} = translationSlice.actions
export default translationSlice.reducer
